import React from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { NavigationButton } from "../NavigationButton";

import { logoutUser } from "../../../store/authSlice";
import { persistor } from "../../../store";
import {
  clearSchedule,
  fetchTeacherAccountSchedule,
} from "../../../store/scheduleSlice";
import { fetchStudentsGroups } from "../../../store/selectsData";
import { clearNotifications } from "../../../store/notificationSlice";
import { clearScheduleType } from "../../../store/weekDataSlice";

import userIcon from "../../../assets/images/buttonIcons/User.svg";
import calendarIcon from "../../../assets/images/buttonIcons/Calendar.svg";
import userManualIcon from "../../../assets/images/buttonIcons/InfoSquare.svg";
import logoutIcon from "../../../assets/images/buttonIcons/Logout.svg";
import statisticIcon from "../../../assets/images/buttonIcons/Chart.svg";
import bookIcon from "../../../assets/images/buttonIcons/Document.svg";

export const TeacherNavButtons = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    dispatch(logoutUser());
    dispatch(clearSchedule());
    dispatch(clearScheduleType());
    dispatch(clearNotifications());
    persistor.purge();
    navigate("/login");
  };

  const getSchedule = () => {
    dispatch(fetchTeacherAccountSchedule());
  };

  const getGroups = () => {
    dispatch(fetchStudentsGroups());
  };

  return (
    <>
      <div className="sidebar">
        <NavigationButton
          to="/teacher_profile"
          onClick={getGroups}
          icon={userIcon}
          text="Мой профиль"
          isActive={location.pathname === "/teacher_profile"}
        />
        <NavigationButton
          to="/schedule"
          icon={calendarIcon}
          text="Расписание"
          isActive={location.pathname === "/schedule"}
          onClick={getSchedule}
        />
        <NavigationButton
          to="https://ebook.vstu.by/"
          icon={bookIcon}
          text="Журнал"
        />
        <NavigationButton
          to="http://192.168.50.26:8082/auth"
          icon={statisticIcon}
          text="Рейтинг"
        />
        <div className="dividing_line"></div>
        <NavigationButton
          to="/manual"
          icon={userManualIcon}
          text="Руководство пользователя"
          isActive={location.pathname === "/manual"}
        />
        <button onClick={handleLogout} className="sidebar-button">
          <div className="button-content">
            <img src={logoutIcon} alt="Button icon" className="button_icon" />
            <span className="button_text">Выйти из профиля</span>
          </div>
        </button>
      </div>
    </>
  );
};
